import { CHUNK_SIZE } from './constants';

export const getChunkSize = (size: number) => {
  return CHUNK_SIZE;
};
